import { webFetch } from "utilities/webFetch";
import config from "utilities/config";
import { AutomaticAppointmentInformation, AutomaticAppointmentStatus } from "./automaticAppointment";

export interface AutomaticAppointmentDtoV2 {
  appointmentInformation: AutomaticAppointmentInformation,
  appointmentCandidates: AppointmentCandidateResponse,
}

export interface AppointmentCandidateResponse {
  candidates: AppointmentAssignmentCandidate[],
  dateRangeEnd: string,
}

export interface AppointmentAssignmentCandidate {
  fieldRepNumber: number,
  appointmentDateTime: string,
  distanceToCase: number,
  rank: number,
}

export interface AutomaticAppointmentSubmitV2 {
  callMeRequested?: boolean,
  candidate: AppointmentCandidateSubmission,
}

export interface AppointmentCandidateSubmission {
  fieldRepNumber: number,
  appointmentDateTime: string,
  confirmationMessageRecipients: string[],
}

export interface BookingSiteSubmitResponse {
  success: boolean,
  needsRefresh: boolean,
  invalidateSelectedOnly: boolean,
}

const baseUrl = "automatic-appointment-v2";

export const getAppointmentInformation = (workItemId: string, campaign: string, routeKey: string, onSuccess: (data: AutomaticAppointmentDtoV2) => void) => {
  if (config.env === "local" && workItemId === "00000000-0000-0000-0000-000000000000") { 
    let mockData = mockAppointmentInformation;
    // mockData.appointmentCandidates.candidates = [];
    onSuccess(mockData);
  }
  else {
    let url = `/${baseUrl}/${workItemId}/${campaign}`;
    if (routeKey)
      url = `${url}/${routeKey}`;

    webFetch({
      url: url,
      method: "GET",
      onSuccess: onSuccess,
    });
  }
};

export const postAppointmentSelection = (
  workItemId: string
  , campaign: string
  , routeKey: string
  , body: AutomaticAppointmentSubmitV2
  , onSuccess: (data?: BookingSiteSubmitResponse) => void
  , onFailure: (data?: any) => void) => {
  let url = `/${baseUrl}/${workItemId}/${campaign}`;
  if(routeKey)
    url = `${url}/${routeKey}`;
  
  webFetch({
    url: url,
    method: "POST",
    body: body,
    onSuccess: onSuccess,
    onFailure: onFailure,
  })
};

const mockAppointmentInformation: AutomaticAppointmentDtoV2 = {
  appointmentInformation: {
    policyHolderName: "Mock Policyholder",
    address: "63 Main Street",
    company: "Mueller Reports",
    logoUrl: "",
    agent: "Mock Agent",
    apptDate: null,
    apptTimeCode: null,
    appointmentStatus: AutomaticAppointmentStatus.WebsiteVisit_SmsLink,
    isAppraisal: false,
    isWithinCallCenterHours: true,
    muellerPhoneNumber: "1-800-555-3455",
    isCallCenterEligible: true,
    hasAppointmentSet: true,
  },
  appointmentCandidates: {
    candidates: [
      {
        fieldRepNumber: 123456,
        appointmentDateTime: "2024-08-04T10:00:00.193"
        ,
        distanceToCase: 18.52179696,
        rank: 1
      },
      {
        fieldRepNumber: 123456,
        appointmentDateTime: "2024-08-15T14:00:00.193",
        distanceToCase: 18.52179696,
        rank: 2
      },
      {
        fieldRepNumber: 123456,
        appointmentDateTime: "2024-08-04T15:00:00.193",
        distanceToCase: 18.52179696,
        rank: 3
      },
      {
        fieldRepNumber: 123456,
        appointmentDateTime: "2024-08-01T14:00:00.193",
        distanceToCase: 18.52179696,
        rank: 4
      },
      {
        fieldRepNumber: 123456,
        appointmentDateTime: "2024-08-06T10:00:00.193",
        distanceToCase: 18.52179696,
        rank: 5
      },
    ],
    dateRangeEnd: "2024-08-6T15:00:00",
  }
};